import { useRef } from 'react'
import PropTypes from 'prop-types'

import { colors } from '@lmc/common/constants'

import Highcharts from 'highcharts'
import ReactHighcharts from 'highcharts-react-official'

export const BarChart = (props: any) => {
  const { type = 'column', height = 500 } = props
  const chartComponentRef = useRef(null)

  const config = {
    credits: {
      enabled: false,
    },
    chart: {
      height,
      type,
      backgroundColor: colors.background,
      spacingTop: 4,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 1,
    },
    legend: {
      enabled: props.legend,
      reversed: props.legend.reversed,
      verticalAlign: 'top',
      padding: 0,
      itemMarginBottom: 10,
      symbolRadius: props.symbolRadius,
    },
    title: {
      text: props.title,
    },
    subtitle: {
      text: props.subtitle,
    },
    xAxis: {
      categories: props.categories,
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: props.yAxisLabel,
      },
      labels: {
        format: props.yAxisTickFormat,
      },
      tickInterval: props.yAxisTickInterval,
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
    },

    plotOptions: {
      turboThreshold: 10000,
      series: {
        borderRadius: props.stacked ? 0 : 4,
      },
      column: {
        stacking: props.stacked
          ? props.stacked === 'percent'
            ? 'percent'
            : 'normal'
          : null,
        groupPadding: 0,
        borderWidth: 0,
      },
      bar: {
        stacking: props.stacking || 'percent',
        borderWidth: 0,
      },
    },
    series: props.series,
  }
  return (
    <div style={styles.container}>
      <ReactHighcharts
        options={config}
        highcharts={Highcharts}
        ref={chartComponentRef}
        config={config}
      />
    </div>
  )
}

const styles = {
  container: {
    paddingBottom: 20,
  },
}

BarChart.propTypes = {
  height: PropTypes.number,
  type: PropTypes.string,
}

export default BarChart
